<template>
  <v-container>
    <h1 class="text-center">ONLINE DASHBOARD</h1>
  </v-container>
</template>

<script>
export default {};
</script>

<style>
</style>